/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, FieldArray } from "formik";

import MaskedInput from "react-text-mask";
import InputField from "../../../components/Form/components/InputField";
import ContainerForm from "../../../components/Form/components/ContainerForm";
import useSender from "./hooks/useSender";
import mask from "../../../services/utils/mask";
import Select from "~components/Form/components/Select";
import prepareForOptions from "~services/utils/prepareForOptions";
import { SaveIndexBD, removeLocalStorage } from "~services/utils/SaveIndexBD";
import ModalAction from "~components/Modal/ModalAction";
import useModalAction from "~components/Modal/hooks/useModalAction";
import { GetIndexBD } from "~services/utils/GetIndexBD";
import { useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
import { useSalvarEmissor } from "../hooks/useWallet";
import useSelect from "~components/Form/hooks/useSelect";
import { set, get } from "idb-keyval";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import ModalResponse from "~components/Modal/ModalResponse";
import Loader from "~components/Form/components/Loader";

import {
  // classificacaoFiscalDefaultOptions,
  recebimentoDefaultOptions,
  setEmptyToSelectsOptions,
  tipoPessoaDefaultOptions,
  defaultEmptyMessages
} from "~services/utils/defaultOptions";
import originControl from "~services/utils/originControl";
import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useSegmento from "~/fetchs/useSegmento";
import useAll from "~/fetchs/useAll";
import useUsuario from "~/fetchs/useUsuario";
import useParametros from "~fetchs/useParametros";
import { DeleteEdit } from "~misc/icons";
import useCargo from "~fetchs/useCargo";
import ModalContato from "~components/Modal/ModalContato";
import Info from "~components/Form/components/Info";

import { useToast } from "@chakra-ui/react";
import useEquipeVenda from "~fetchs/useEquipeVenda";
import useEscritorioVenda from "~fetchs/useEscritorioVenda";
import ModalContatoSalvos from "~components/Modal/ModalContatoSalvo";

const CreateForm = ({ setBackRoute }) => {
  const { usuario } = useUsuario();
  const ArrayContatoRef = useRef();
  const formikRef = useRef();

  const { onChangeTipoPessoa, tipoPessoaSelect, isPessoaFisica, recebimentoSelect, onChangeRecebimento } = useAll(formikRef);
   const [formModalValues, setFormModalValues] = useState({});
  const [formModalValuesCreate, setFormModalValuesCreate] = useState({});

  const navigate = useNavigate();
  const {
    validationSchema,
    initialValues,
    setinitialValues,
    completeDate,
  } = useSender(0, isPessoaFisica);

  const {
    getOrigem,
    origens,
    getPersistentParameters,
    setPersistentParameters,
    persistentParameters
  } = originControl();

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();
      const {
    isModalOpenAction: isModalContatoSalvar,
    closeModalAction: closeModalContatoSalvar,
    openModalAction: openModalContatoSalvar,
  } = useModalAction();
  const [loading, setLoading] = useState(false);

  //Selects
  const [conversaoProspect, setConversaoProspect] = useState({});
  const [dataComingBack, setDataComingBack] = useState({});

  const { cpfCnpj, formatCpfCnpjValue } = mask();

  //OPTIONS
  const recebimentoOptions = recebimentoDefaultOptions;
  const tipoPessoaOptions = tipoPessoaDefaultOptions;

  //States
  const [localidade, setLocalidade] = useState("");
  const [emissorData, setEmissorData] = useState({});
  const [selectedContact, setSelectedContact] = useState({});

  //IndexsDB
  const { optionsTrilha, trilha, trilhas, SetSelectTrilha, onChangeTrilha, trilhaSelect, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
  const { optionsEquipe, equipe, SetSelectEquipe,clearEquipe, onChangeEquipe, equipeSelect } = useEquipeVenda(formikRef);
  const { optionsEscritorio, escritorio, SetSelectEscritorio, clearEscritorio, onChangeEscritorio, escritorioSelect } = useEscritorioVenda(formikRef,  equipeSelect);
  const { optionsCargo, cargoSelect, handleCargoChange, SetSelectCargo } = useCargo(formikRef);
  const {
    gruposCentralizadores,
    optionGruposCentralizadores,
    grupoCentralizadorSelect,
    onChangeGrupoCentralizador,
    SetSelectGrupoCentralizador
  } = useGrupoCentralizador(formikRef);
  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, onChangeGrupoSegmento, SetSelectGrupoSegmento } = useGrupoSegmento({ formikRef, trilha });
  const { optionsSegmento, segmentoSelect, onChangeSegmento, SetSelectSegmento } = useSegmento(grupoSegmento, formikRef);
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const grupoCentralizadorConstrutoraOptions = useMemo(() => {
    const filtrados = (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha);
    return prepareForOptions(filtrados, ["codigo", "nome"], "id");
  }, [gruposCentralizadores, trilha]);
  const filteredGrupoCentralizador = useMemo(() => (gruposCentralizadores || []).filter((g) => g.trilhaId === trilha), [gruposCentralizadores, trilha]);
  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);

  const loadGrupoOptions = useCallback(() => {
    if ( grupoOptionsLoaded ) return;
    setGrupoLoading(true);
    setTimeout(() => {
      const opts = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(opts);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 50);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);
  useEffect(() => {
    const currentId = formikRef.current?.values?.grupoCentralizadorConstrutoraId;
    if (currentId) {
      const opt = grupoCentralizadorConstrutoraOptions.find((o) => String(o.value) === String(currentId));
      if (opt) setSelectedGrupoOption(opt);
    }
  }, [grupoCentralizadorConstrutoraOptions]);

  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);
  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId =
    trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;
  const acessoJornadaFunil = ["IMO", "INFRA"].includes(
    trilhas.find((item) => String(item.id) === String(trilha))?.nome?.toUpperCase()
  ) && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');
  const prospectOrigem = persistentParameters.split(',').includes(origens.conversao_prospect)
    ? Number(conversaoProspect?.id || (emissorData?.conversao ? emissorData.id : 0)) : 0;
  const newContato = {
    nome: "",
    sobrenome: "",
    cargoId: null,
    email: "",
    telefone: "",
    celular: "",
  };

  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };

  useEffect(() => {
    if (!formikRef.current) return;

    if (!isTrilhaPermitida) {
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoCentralizadorConstrutoraOptions?.length) return;

    const currentId = formikRef.current.values?.grupoCentralizadorConstrutoraId;
    if (currentId === null || currentId === undefined || currentId === "") return;

    const currentOption = grupoCentralizadorConstrutoraOptions.find(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, grupoCentralizadorConstrutoraOptions, trilha]);

  useEffect(() => {
    if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
      loadGrupoOptions();
    }
  }, [isTrilhaPermitida, filteredGrupoCentralizador, loadGrupoOptions]);

  //Functions
  function SetSelects(data) {
    SetSelectTrilha(data?.trilhaId);
    SetSelectGrupoCentralizador(data?.grupoCentralizadorId);
    SetSelectSegmento(data?.segmentoId);
    SetSelectGrupoSegmento(data?.grupoSegmentoId);

    const optionTipoPessoa = tipoPessoaOptions.find((opt) => opt.value === data?.tipo);

    if (optionTipoPessoa) onChangeTipoPessoa(optionTipoPessoa);

    setinitialValues({
      ...initialValues,
      codigoSAP: data?.codigoSAP,
      codigoVendedor: data?.codigoVendedor,
      descargaCliente: data?.descargaCliente,
      descargaFumaca: data?.descargaFumaca,
      grupoCentralizadorConstrutoraId: data?.grupoCentralizadorConstrutoraId ?? null
    });
  }


  async function checkOrigem() {
    const origem = getOrigem();

    let pp = await getPersistentParameters();
    pp = Array.isArray(pp) ? pp.filter(e => e != "cadastro-emissor") : [];
    setPersistentParameters(pp.join(','));
    const lastParam = pp.length > 0 ? pp[pp.length - 1] : "";

    if (origem == origens.conversao_prospect || lastParam == origens.conversao_prospect) {
      const prospect = await GetIndexBD("conversao-prospect");

      setConversaoProspect(prospect);
    } else if (origem == origens.busca_online) {
      SaveIndexBD("conversao-prospect", {});
      setBackRoute(`${initialPath}/carteira/busca/online`);
    }
    else if ([origens.edicao_recebedor, origens.solicitar_credito].includes(origem)) {
      setDataComingBack(await GetIndexBD("retornar-dados-emissor"));

      if (pp && (Array.isArray(pp) && pp.length == 0) || (!pp.includes(origens.busca_online) && !pp.includes(origens.conversao_prospect))) {
        setBackRoute(`${initialPath}/cadastro-e-credito`);
      }
    }

    if (!(origem == origens.conversao_prospect && lastParam == origens.conversao_prospect)) {
      SaveIndexBD("conversao-prospect", {});
    }
  }

  //Requests
  const onSuccess = (data) => {
    StatusRetorno();
    setLoading(false);

    const cliente = emissorData?.conversao ? data : data?.data;
    const clienteId = cliente?.clienteEmissor?.id ?? cliente?.id;

    if (acessoJornadaFunil && clienteId) {
      const parametros = new URLSearchParams({ origem: origens.solicitar_credito, "limite-credito": "pulado", pp: pp.join(',') });
      if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
      navigate(`${initialPath}/carteira/emissor/${clienteId}?${parametros}`);
      return;

    }

    navigate(`${initialPath}/carteira/solicitacoes`);
  }

  const onError = () => {
    setLoading(false);
  }

  const emissorSalvar = useSalvarEmissor(emissorData, onSuccess, onError);

  const { formatNumber } = mask();

  const {
    isModalOpenAction: isModalRecebedorOpenAction,
    closeModalAction: closeModalRecebedorAction,
    openModalAction: openModalRecebedorAction,
    setModalOpenAction: setModalRecebedorOpenAction,
  } = useModalAction();
  const {
    isModalOpenAction: isModalLimiteOpenAction,
    closeModalAction: closeModalLimiteAction,
    openModalAction: openModalLimiteAction,
    setModalOpenAction: setModalLimiteOpenAction,
  } = useModalAction();

  //useEffects
  useEffect(() => {
    if (conversaoProspect && Object.keys(conversaoProspect).length > 0) {
      SetSelects(conversaoProspect);

      setinitialValues({
        ...initialValues,
        tipo: conversaoProspect?.tipo,
        cep: conversaoProspect?.endereco?.cep,
        id: conversaoProspect?.id,
        cidade: conversaoProspect?.cidade,
        numero: conversaoProspect?.endereco?.numero,
        rua: conversaoProspect?.endereco?.rua,
        bairro: conversaoProspect?.endereco?.bairro,
        complemento: conversaoProspect?.endereco?.complemento,
        documento: formatCpfCnpjValue(conversaoProspect?.documento),
        nomeFantasia: conversaoProspect?.nomeFantasia,
        inscricaoEstadual: conversaoProspect?.inscricaoEstadual,
        inscricaoMunicipal: conversaoProspect?.inscricaoMunicipal,
        conversao: true,
        email: conversaoProspect?.contatos?.length > 0 ? conversaoProspect.contatos[0].email : null,
        telefone: conversaoProspect?.contatos?.length > 0 ? conversaoProspect.contatos[0].telefone : null,
        celular: conversaoProspect?.contatos?.length > 0 ? conversaoProspect.contatos[0].celular : null,
        dataNascimento: conversaoProspect.dataNascimento?.split('T')[0].split('-')?.reverse()?.join('/'),
        contatos: conversaoProspect?.contatos?.map((contato, index) => {
          return {
            nome: contato?.nome,
            sobrenome: contato?.sobrenome,
            cargoId: contato.cargoContato?.id ? contato.cargoContato?.id : null,
            cargo: contato.cargoContato?.nome ? contato.cargoContato?.nome : '',
            email: contato?.email,
            telefone: contato?.telefone,
            celular: contato?.celular,
          }
         })
      });
    }
  }, [conversaoProspect]);

  useEffect(() => {
    if (dataComingBack && Object.keys(dataComingBack).length > 0) {
      SetSelects(dataComingBack);

      setinitialValues({
        ...initialValues,
        cep: dataComingBack?.cep,
        id: dataComingBack?.id,
        numero: dataComingBack?.numero,
        rua: dataComingBack?.rua,
        bairro: dataComingBack?.bairro,
        complemento: dataComingBack?.complemento,
        documento: dataComingBack?.documento,
        nomeFantasia: dataComingBack?.nomeFantasia,
        dataNascimento: dataComingBack?.dataNascimento,
        telefone: dataComingBack?.telefone,
        celular: dataComingBack?.celular,
        inscricaoEstadual: dataComingBack?.inscricaoEstadual,
        inscricaoMunicipal: dataComingBack?.inscricaoMunicipal,
        email: dataComingBack?.email,
        recebimento: dataComingBack?.recebimento,
        tipo: dataComingBack?.tipo,
        cidade: {
          nome: dataComingBack?.cidadeLabel,
          id: dataComingBack?.cidadeId,
          estado: {
            nome: dataComingBack?.ufLabel,
            sigla: dataComingBack?.uf
          }
        }
      });

      if (dataComingBack?.recebimento) {
        onChangeRecebimento(
          recebimentoOptions.find((e) => e.value == dataComingBack.recebimento)
        );
      }

      removeLocalStorage("retornar-dados-emissor");
    }
  }, [dataComingBack]);

  useEffect(() => {
    checkOrigem();
  }, []);

  useEffect(() => {
    if (usuario?.codigo && formikRef.current) {
      formikRef.current.setFieldValue("codigoVendedor", usuario?.codigo);
    }
  }, [usuario?.codigo, formikRef.current]);

  function StatusRetorno() {
    setModalRecebedorOpenAction(false);
    setModalLimiteOpenAction(false);
    SaveIndexBD("form-new-emissor", {});
    SaveIndexBD("conversao-prospect", {});
  }

  useEffect(() => {
    if (Object.keys(emissorData).length > 0) {
      setLoading(true);
      emissorSalvar();
    }
  }, [emissorData]);

  const [cpfCnpjTeste, setCpfCnpj] = useState("");

  function onChangeCpfCnpj(value) {
    setCpfCnpj(value);
  }

  const pp = persistentParameters.split(',').filter(e => e != "");
  pp.push('cadastro-emissor');

  //Functions
  async function SimRecebedor() {
    removeLocalStorage("conversao-prospect");
    const parametros = new URLSearchParams({ origem: origens.cadastro_emissor, pp: pp.join(',') });
    if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
    navigate(`${initialPath}/carteira/recebedor/novo?${parametros}`);
  }

  async function NaoRecebedor() {
    openModalLimiteAction();
    closeModalRecebedorAction();
  }

  function SimLimite() {
    const parametros = new URLSearchParams({ origem: origens.cadastro_emissor, pp: pp.join(',') });
    if (prospectOrigem > 0) parametros.set("prospect-origem", prospectOrigem);
    navigate(`${initialPath}/carteira/credito/novo?${parametros}`);
  }

  async function NaoLimite() {
    const values = await GetIndexBD("form-new-emissor");
    closeModalLimiteAction();
    setEmissorData({
      ...values,
      dataNascimento: values?.dataNascimento ? values.dataNascimento : null,
      grupoCentralizadorId: values?.grupoCentralizadorId ? values.grupoCentralizadorId : null,
      grupoCentralizadorConstrutoraId: values?.grupoCentralizadorConstrutoraId ?? null,
    });
  }

  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }
  function HandleRemoveBlock(arrayContatos, index) {
    setIsConfirmationOpen(true);
    setIndexBlock(index);

    const contatos = (formikRef?.current?.values?.contatos || []).filter((contato, idx) => idx !== index);
    formikRef?.current?.setFieldValue("contatos", contatos);

    setremoveBlock((prevState) => ({
      // Mantenha os valores antigos do estado
      ...prevState,
      // Atualize o arrayContatos adicionando um novoContato
      arrayContatos: [...prevState.arrayContatos, arrayContatos],
      index: index,
    }));
  }
  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }

  const temAlgo = Object.keys(conversaoProspect).length > 0;


    const toast = useToast();
    const deleteContato = (index) => {


    if (Array.isArray(initialValues.contatos)) {
      initialValues.contatos = initialValues.contatos.filter(
        (_, i) => i !== index
      );
    }

    setinitialValues({
      ...initialValues,
      contatos: initialValues.contatos
    });

     toast({
        title: `Contato deletado com sucesso!`,
        description: "",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });
    initialValues.contatos.length <= 1 ? closeModalContatoSalvar() : null;
  };

  const editContato = (index) => {

    if (Array.isArray(initialValues.contatos)) {
      const contato = initialValues.contatos[index];
      setSelectedContact(contato);
      closeModalContatoSalvar();
      openModal();
    }
  };




 const storedTrilha = useRef(0);
    if (trilha !== 0 && trilha !== storedTrilha.current) {
      console.log(`Trilha mudou de ${storedTrilha.current} para ${trilha}`);
      storedTrilha.current = trilha;
      clearEquipe();
      clearEscritorio();
    }

  return (
    <>
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={async (values, actions) => {
        if (isTrilhaIMO && isTrilhaPermitida && !values.grupoCentralizadorConstrutoraId) {
          actions.setFieldError(
            "grupoCentralizadorConstrutoraId",
            "Grupo Centralizador Construtoras e obrigatorio"
          );
          return;
        }

        let valuesSubmit = values;
        valuesSubmit.email = values.contatos[0].email || '';
        valuesSubmit.celular = values.contatos[0].celular || '';
        valuesSubmit.telefone = values.contatos[0].telefone || '';

        const primeiroContato = values.contatos[0];
        if (formModalValues?.contatos && formModalValues.contatos.length > 0) {
          valuesSubmit.contatos = [primeiroContato, ...formModalValues.contatos];
        } else {
          valuesSubmit.contatos = [primeiroContato];
        }

        try {
          setLoading(true);
          if (conversaoProspect) {
            values.usuarioId = conversaoProspect.usuarioId;
            values.codigoProspect = conversaoProspect.codigoProspect;
          }
          SaveIndexBD("form-new-emissor", valuesSubmit);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          openModalRecebedorAction().then(() => {
            setLoading(false);
          });
        } finally {
          setLoading(false);
        }

      }}
    >
      {({ values, errors, touched, setFieldValue, setFieldTouched, isSubmitting }) => (
        <>
        <Form className="mt-[-4rem] relative" id="emissor">
          <div
            className={loading ? "relative spinner__form-active" : "relative"}
          >
            <ContainerForm title="Dados Cadastrais">
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-2">
                <InputField
                  labelName="Código SAP:"
                  inputName="codigoSAP"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                <InputField
                  labelName="Código Vendedor:"
                  inputName="codigoVendedor"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
              </div>
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-2">
                <Select
                  name="tipo"
                  label="Tipo Pessoa:"
                  placeholder="Tipo Pessoa:"
                  options={tipoPessoaOptions}
                  onChange={(e) => {
                    onChangeTipoPessoa(e);
                  }}
                  errors={errors.tipo}
                  touched={touched.tipo}
                  isRequired
                  {...tipoPessoaSelect}
                />

                <InputField
                  labelName="CNPJ/CPF:"
                  inputName="documento"
                  as={MaskedInput}
                  mask={cpfCnpj}
                  inputMask="onmask"
                  inputType="text"
                  isRequired
                  forceUppercase
                  onBlur={() => onChangeCpfCnpj(values.documento)}
                />
              </div>
              {values.tipo == 1 && (
                <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-2">
                  <InputField
                    labelName="Inscrição Municipal:"
                    inputName="inscricaoMunicipal"
                    inputMask="offmask"
                    inputType="text"
                  />
                  <InputField
                    labelName="Inscrição Estadual:"
                    inputName="inscricaoEstadual"
                    inputMask="offmask"
                    inputType="text"
                  />
                </div>
              )}
              <div
                className={`grid gap-x-2 md:grid-cols-1 ${values.tipo == 1 ? "lg:grid-cols-2" : "lg:grid-cols-1"
                  }`}
              >
                <InputField
                  labelName={`Nome ${values.tipo != 1 ? 'Fantasia' : ''}:`}
                  inputName="nomeFantasia"
                  inputMask="offmask"
                  inputType="text"
                  isRequired
                />
                {values.tipo == 1 ? (
                  <InputField
                    labelName="Data de Nascimento:"
                    inputName="dataNascimento"
                    as={MaskedInput}
                    mask={completeDate}
                    isRequired={values.tipo == 1}
                    inputMask="onmask"
                    inputType="text"
                  />
                ) : null}
              </div>

              <div className={`${values.tipo == 1 ? '' : 'hidden'}`}>
                <AddressForm formikRef={formikRef} isCepRequired={true} />
              </div>
            </ContainerForm>

        <FieldArray
              name="contatos"
              render={(arrayContatos) => {
                ArrayContatoRef.current = arrayContatos;

                return (
                  <div className="container relative">
                    <ContainerForm title="Dados Pessoais">
                       {temAlgo && values.contatos[0].nome !== '' && values.contatos.map((data, index) => (
                        <>
                          <div
                            className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                              } ${values.contatos.length > 1 ? " pt-12 " : ""}`}
                            key={index}
                          >
                            {values.contatos.length > 1 && (
                              <button
                                type="button"
                                className="scale-75 absolute top-0 right-0"
                                onClick={() => HandleRemoveBlock(arrayContatos, index)}
                              >
                                <DeleteEdit />
                              </button>
                            )}
                            <InputField
                              className="bg-white"
                              labelName="Nome Contato:"
                              inputName={`contatos[${index}].nome`}
                              inputMask="offmask"
                              inputType="text"
                              difference={true}
                              isRequired
                            />
                            <InputField
                              labelName="Sobrenome Contato:"
                              inputName={`contatos[${index}].sobrenome`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <Select
                              name={`contatos[${index}].cargoId`}
                              label="Cargo:"
                              placeholder=""
                              options={optionsCargo}
                              defaultValue={ data?.cargo && data?.cargoId ? { label: `${data.cargo}`, value: `${data.cargoId}`} :  ""}
                              onChange={(e) => {
                                setFieldValue(`contatos[${index}].cargoId`, e.value);
                                setFieldValue(`contatos[${index}].cargo`, e.label);
                                setTimeout(() => setFieldTouched(`contatos[${index}].cargoId`, true));
                              }}
                              errors={errors.contatos && errors?.contatos[index]?.cargoId}
                              touched={touched.contatos && touched?.contatos[index]?.cargoId}
                              isRequired
                            />
                            <InputField
                              labelName="Email do Contato:"
                              inputName={`contatos[${index}].email`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 1:"
                              inputName={`contatos[${index}].telefone`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 2:"
                              inputName={`contatos[${index}].celular`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              difference={true}
                            />
                          </div>
                          <div className="flex items-center">
                            {((values.contatos.length > 1 && index == values.contatos.length - 1) ||
                              values.contatos.length == 1) && (
                                <button
                                  type="button"
                                  className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search"
                                  onClick={() => arrayContatos.push(newContato)}
                                >
                                  Adicionar um novo contato
                                </button>
                              )}
                          </div>
                        </>
                      ))}
                      {!temAlgo  && values.contatos.map((data, index) => (
                        <>
                          <div
                            className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                              } ${values.contatos.length > 1 ? " pt-12 " : ""}`}
                            key={index}
                          >
                            {values.contatos.length > 1 && (
                              <button
                                type="button"
                                className="scale-75 absolute top-0 right-0"
                                onClick={() => HandleRemoveBlock(arrayContatos, index)}
                              >
                                <DeleteEdit />
                              </button>
                            )}
                            <InputField
                              className="bg-white"
                              labelName="Nome Contato:"
                              inputName={`contatos[${index}].nome`}
                              inputMask="offmask"
                              inputType="text"
                              difference={true}
                              isRequired
                            />
                            <InputField
                              labelName="Sobrenome Contato:"
                              inputName={`contatos[${index}].sobrenome`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <Select
                              name={`contatos[${index}].cargoId`}
                              label="Cargo:"
                              placeholder=""
                              options={optionsCargo}
                              defaultValue={ data?.cargo && data?.cargoId ? { label: `${data.cargo}`, value: `${data.cargoId}`} :  ""}
                              onChange={(e) => {
                                setFieldValue(`contatos[${index}].cargoId`, e.value);
                                setFieldValue(`contatos[${index}].cargo`, e.label);
                                setTimeout(() => setFieldTouched(`contatos[${index}].cargoId`, true));
                              }}
                              errors={errors.contatos && errors?.contatos[index]?.cargoId}
                              touched={touched.contatos && touched?.contatos[index]?.cargoId}
                              isRequired
                            />
                            <InputField
                              labelName="Email do Contato:"
                              inputName={`contatos[${index}].email`}
                              inputMask="offmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 1:"
                              inputName={`contatos[${index}].telefone`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 2:"
                              inputName={`contatos[${index}].celular`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              difference={true}
                            />
                          </div>
                          <div className="flex items-center">
                            {((values.contatos.length > 1 && index == values.contatos.length - 1) ||
                              values.contatos.length == 1) && (
                                <button
                                  type="button"
                                  className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search"
                                  onClick={() => arrayContatos.push(newContato)}
                                >
                                  Adicionar um novo contato
                                </button>
                              )}
                          </div>
                        </>
                      ))}
                    </ContainerForm>
                  </div>
                );
              }}
            ></FieldArray>


            <ContainerForm title="Informações Adicionais">
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-3">
                <Select
                  name="trilhaId"
                  label="Trilha Global:"
                  placeholder="Trilha Global:"
                  options={optionsTrilha}
                  noOptionsMessage="Trilha não encontrado"
                  isRequired
                  onChange={(e) => {
                    onChangeTrilha(e);
                  }}
                  errors={errors.trilhaId}
                  touched={touched.trilhaId}
                  {...trilhaSelect}
                />
                <Select
                  name="grupoSegmentoId"
                  label="Grupo Segmento:"
                  placeholder="Grupo Segmento:"
                  isRequired
                  options={optionsGrupoSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={(e) => {
                    onChangeGrupoSegmento(e);
                  }}
                  isDisabled={!values.trilhaId}
                  errors={errors.grupoSegmentoId}
                  touched={touched.grupoSegmentoId}
                  {...grupoSegmentoSelect}
                />
                <Select
                  name="segmentoId"
                  label="Segmento:"
                  placeholder="Segmento:"
                  isRequired
                  options={optionsSegmento}
                  noOptionsMessage="Segmento não encontrado"
                  onChange={(e) => {
                    onChangeSegmento(e);
                  }}
                  isDisabled={!values.grupoSegmentoId}
                  errors={errors.segmentoId}
                  touched={touched.segmentoId}
                  {...segmentoSelect}
                />
                <Select
                  name="grupoCentralizadorId"
                  label="Grupo Centralizador:"
                  placeholder="Grupo Centralizador:"
                  options={setEmptyToSelectsOptions(optionGruposCentralizadores, defaultEmptyMessages.grupoCentralizador)}
                  noOptionsMessage="Grupo não encontrado"
                  labelTooltip={
                    isTrilhaPermitida && (
                      <Info
                        bg="blue"
                        position="mobile-left"
                        text={
                          <>
                            Atualização do campo será feita após validação do <strong>GRUPO CENTRALIZADOR CONSTRUTORAS</strong>
                          </>
                        }
                        tooltipClass="w-4 h-4 relative mt-1"
                      />
                    )
                  }
                  onChange={(e) => {
                    onChangeGrupoCentralizador(e);
                  }}
                  errors={errors.grupoCentralizadorId}
                  touched={touched.grupoCentralizadorId}
                  isDisabled={true}
                  {...grupoCentralizadorSelect}
                />
                {/* optionsEquipe, equipe, SetSelectEquipe, onChangeEquipe, equipeSelect */}
                <Select
                  name="recebimento"
                  label="Forma de Recebimento NFe:"
                  placeholder="Forma de Recebimento NFe:"
                  options={recebimentoOptions}
                  noOptionsMessage="Forma de Recebimento NFe não encontrada"
                  isRequired
                  onChange={(e) => {
                    onChangeRecebimento(e);
                  }}
                  errors={errors.recebimento}
                  touched={touched.recebimento}
                  {...recebimentoSelect}
                />
                 <Select
                  name="equipeVendaId"
                  label="Equipe de venda:"
                  placeholder="Equipe de venda:"
                  options={optionsEquipe}
                  noOptionsMessage="Equipe de venda não encontrada"

                  onChange={(e) => {
                    onChangeEquipe(e);
                  }}
                  errors={errors.equipeVendaId}
                  touched={touched.equipeVendaId}
                  {...equipeSelect}
                />
                <Select
                  name="escritorioVendaId"
                  label="Escritório de Venda:"
                  placeholder="Escritório de Venda:"
                  options={optionsEscritorio}
                  noOptionsMessage="Escritório de Venda não encontrado"
                  onChange={(e) => {
                    onChangeEscritorio(e);
                  }}
                  errors={errors.escritorioVendaId}
                  touched={touched.escritorioVendaId}
                  {...escritorioSelect}
                />
                  {isTrilhaPermitida && (
                    <Select
                      name="grupoCentralizadorConstrutoraId"
                      label="Grupo Centralizador Construtoras:"
                      placeholder="Grupo Centralizador Construtoras:"
                      options={
                        grupoOptionsLoaded
                          ? grupoOptionsState
                          : selectedGrupoOption
                          ? [selectedGrupoOption]
                          : []
                      }
                      noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                      onChange={onChangeGrupoCentralizadorConstrutora}
                      errors={errors.grupoCentralizadorConstrutoraId}
                      touched={touched.grupoCentralizadorConstrutoraId}
                      isRequired={isTrilhaIMO}
                      loading={grupoLoading}
                      isDisabled={grupoLoading || !values.trilhaId}
                      {...grupoCentralizadorConstrutoraSelect}
                    />
                  )}
              </div>

              <div className="grid gap-x-4 mt-4 grid-cols-2 lg:grid-cols-3">
                <div>
                  <label className="flex items-center space-x-2">
                    <Field
                      type="checkbox"
                      name="descargaCliente"
                      className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                    />
                    <span className="text-gray-700">Descarga no Cliente</span>
                  </label>
                </div>
                {errors.descargaCliente && (
                  <p style={{ color: "red" }}>{errors.descargaCliente}</p>
                )}
              </div>
            </ContainerForm>
          </div>

          {loading && (
            <>
              <div className="spinner__form ">
                <Loader />
              </div>
            </>
          )}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />

          <ModalAction
            isOpen={isModalRecebedorOpenAction}
            onClose={closeModalRecebedorAction}
            title="Deseja cadastrar um código recebedor?"
            sub="(Endereço adicional)"
            buttonOne="Sim"
            buttonTwo="Não"
            linkOne={SimRecebedor}
            linkTwo={NaoRecebedor}
          />

          <ModalAction
            isOpen={isModalLimiteOpenAction}
            onClose={closeModalLimiteAction}
            title="Deseja cadastrar um limite de crédito?"
            buttonOne="Sim"
            buttonTwo="Não"
            linkOne={SimLimite}
            linkTwo={NaoLimite}
          />
        </Form>
          <ModalContato  formModalValuesCreate={formModalValuesCreate} setFormModalValuesCreate={setFormModalValuesCreate} isOpen={isModalOpen} onClose={closeModal} openModalContatoSalvar={openModalContatoSalvar} optionsCargo={optionsCargo} emissorData={initialValues}  setinitialValues={setinitialValues} initialValues={initialValues} selectedContact={selectedContact}  setSelectedContact={setSelectedContact} />
          <ModalContatoSalvos formModalValuesCreate={formModalValuesCreate} setFormModalValuesCreate={setFormModalValuesCreate} formModalValues={formModalValues} setFormModalValues={setFormModalValues} optionsCargo={optionsCargo} deleteContato={deleteContato} isOpen={isModalContatoSalvar}  onClose={closeModalContatoSalvar}  initialValues={initialValues} setinitialValues={setinitialValues} setFieldValue={setFieldValue} />
        </>
        )

      }
    </Formik>

    </>
  );
};

export default CreateForm;
